// src/UsernameGate.jsx
// Render once in App.jsx. Shows the mandatory popup until the user has a username.
// Reads: 0 once the localStorage flag is set; otherwise 1 read of users/{uid}.
import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import CompleteProfileModal from "./CompleteProfileModal";
import {
  hasUsernameFlag,
  setUsernameFlag,
  suggestFromName,
} from "./utils/usernameService";

const UsernameGate = () => {
  const [pending, setPending] = useState(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(getAuth(), async (user) => {
      if (!user) {
        setPending(null);
        return;
      }
      if (hasUsernameFlag(user.uid)) {
        setPending(null);
        return;
      }

      try {
        const snap = await getDoc(doc(getFirestore(), "users", user.uid));
        const data = snap.exists() ? snap.data() : {};

        if (data.username) {
          setUsernameFlag(user.uid);
          setPending(null);
          return;
        }

        setPending({
          uid: user.uid,
          bio: data.bio || "",
          suggestion: suggestFromName(
            data.authorName || user.displayName,
            user.email || ""
          ),
          avatarUrl: user.photoURL?.startsWith("http") ? user.photoURL : null,
        });
      } catch (e) {
        // If the read fails, don't block the app; the check runs again next open.
        console.error("Username check failed", e);
      }
    });
    return unsub;
  }, []);

  if (!pending) return null;

  return (
    <CompleteProfileModal
      mandatory
      uid={pending.uid}
      suggestion={pending.suggestion}
      initialBio={pending.bio}
      avatarUrl={pending.avatarUrl}
      onSaved={() => setPending(null)}
    />
  );
};

export default UsernameGate;